import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSmile} from '@fortawesome/pro-light-svg-icons';
import {faUserGraduate} from '@fortawesome/pro-duotone-svg-icons';
import {faArrowRight, faComments, faFileAlt, faLaptop, faVideo} from '@fortawesome/pro-solid-svg-icons';
import {IIdentity} from '../../controller/identity';

export interface IWelcomeProps {
    identity?: IIdentity;
}

export const Welcome: React.FunctionComponent<IWelcomeProps> = (props) => {

    let icon: JSX.Element | undefined;
    let funnyhint: JSX.Element | undefined;
    let wisewords: JSX.Element | undefined;

    const dashboardLinks = [
        {
            href: "https://www.institut-sitya.at/hubfs/faq/flex-selbststudium/E-Learning_Anleitung_Flex-Fernstudium_SITYA.pdf",
            icon: faLaptop,
            title: "Lernablauf",
            text: "So funktioniert das Lernen.",
            hint: "Download"
        },
        {
            href: "https://www.institut-sitya.at/hubfs/Schrittanleitung/Schritt-fuer-Schritt_Lernunterlagen_nutzen_Desktop_Mobil_SITYA.pdf",
            icon: faFileAlt,
            title: "Schrittanleitung",
            text: "Technische Nutzung.",
            hint: "Download"
        },
        {
            href: "https://www.institut-sitya.at/lernfrage",
            icon: faComments,
            title: "Lernhilfe",
            text: "Unterstützung bei Fragen.",
            hint: "Anfragen"
        },
        {
            href: "https://www.institut-sitya.at/persoenlichkeitstraining",
            icon: faVideo,
            title: "Videoeinführung",
            text: "Empathie und Selbstwahrnehmung.",
            hint: "Ansehen"
        }
    ];

    const getWiseWords = () => {
        return (
            <div className="translate">
                Willkommen auf Ihrer SITYA E-Learning-Plattform!<br/><br/>
                Hier finden Sie alles für Ihr Lernen - übersichtlich, flexibel und jederzeit verfügbar.<br/><br/>
                Viel Freude beim Lernen und Entdecken!
            </div>
        );
    }

    const getDashboardLinks = () => {
        return (
            <div className="dashboard-link-grid">
                <div className="dashboard-link-heading"><span className="translate">Gut vorbereitet starten</span></div>
                {dashboardLinks.map((link) => (
                    <a key={link.title} href={link.href} target="_blank" rel="noreferrer noopener" className="dashboard-link-card">
                        <FontAwesomeIcon icon={link.icon} className="dashboard-link-icon" />
                        <span className="dashboard-link-title">
                            {link.title}
                            <FontAwesomeIcon icon={faArrowRight} className="dashboard-link-title-arrow" />
                        </span>
                        <span className="dashboard-link-text">{link.text}</span>
                        <span className="dashboard-link-hint">
                            {link.hint}
                            <FontAwesomeIcon icon={faArrowRight} className="dashboard-link-arrow" />
                        </span>
                    </a>
                ))}
            </div>
        );
    }

    if (!props.identity) return null;

    const date = new Date();
    const hours = date.getHours();

    let greeting = "";
    if ((hours >= 21) || (hours < 3)) greeting = "Gute Nacht";
    else if (hours >= 17) greeting = "Guten Abend";
    else if (hours >= 9) greeting = "Guten Tag";
    else if (hours >= 3) greeting = "Guten Morgen";

    let funnytext = "";

    wisewords = <div>{getWiseWords()}</div>;
    if ((hours > 21) || (hours <= 3)) funnytext = " Sie lernen heute spät";

    icon = <figure id="avatar-container" className="image" style={{display: "flex", alignItems: "center"}}>
        <FontAwesomeIcon id="avatar" icon={faUserGraduate}/>
    </figure>;

    if (funnytext) {
        funnyhint = (
            <div className="block is-sub-header">
                <span>
                    {funnytext}
                    <FontAwesomeIcon icon={faSmile} style={{marginLeft: "0.5rem"}}/>
                </span>
            </div>
        );
    }

    return (

        <div>
            <div id="welcome" className="block" style={{display: "flex", alignItems: "center"}}>
                {icon}
                <div id="name">
                    <div className="is-header"><span className="translate">{greeting}</span>,</div>
                    <div className="is-sub-header"><span>{props.identity.name}</span></div>
                </div>
            </div>
            <hr/>
            {funnyhint}
            <div className="block is-larger-text dashboard-intro-text">
                {wisewords}
            </div>
            {getDashboardLinks()}
        </div>
    );
}
